import { Spin } from "antd";

const SuspenseLoader = () => {
  return (
    <div className="bg-white min-h-screen flex justify-center items-center">
      <Spin size="large" style={{ color: "#0AB99D" }} />
    </div>
  );
};

export default SuspenseLoader;
